import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ChatShort } from "../../../shared/models/Chat";

export const useSendUserInput = (chatId: string) => {
  const { call, isLoading: isUserInputLoading } =
    useApiPrivateRequest<ChatShort>((response) => new ChatShort(response));
  const sendUserInput = async (
    input: string,
    companyIds?: number[],
    filingIds?: string[],
    transcriptIds?: string[],
    userDocumentIds?: string[],
  ) => {
    const body = {
      input,
      companyIds,
      filingIds,
      transcriptIds,
      userDocumentIds,
    };

    await call(`/chats/${chatId}/input`, "POST", undefined, body);
  };

  return { isUserInputLoading, sendUserInputV2: sendUserInput };
};
